define([
    'text!index2024-buyChannel/component/input-attach.html',
    'lodash',
    'index2024-buyChannel/api',
    'index2024-buyChannel/common/api',

    'css!index2024-buyChannel/component/input-attach.css'
], function(
    tpl,
    _,
    Api,
    NewApi
){
    return {
        template: tpl,
        props: {
            value: {
                type: Array
            }
        },
        data: function(){
            return {
                maxFileCount: 5
            };
        },
        methods: {
            onInputFileChange: function(event){
                var files = event.target.files;
                if (files.length + this.value.length > this.maxFileCount){
                    return alert('最多上传'+this.maxFileCount+'个文件');
                }
                var _this = this;
                var all = _.map(files, function(file){
                    return _this.uploadFile(file);
                });
                Api.multiPromise(all)
                    .always(function(){
                        event.target.value = '';
                    });
            },
            uploadFile: function(file){
                var uploadFileType = /^image/.test(file.type) ? 'img' : 'doc';
                var formData = new FormData();
                formData.append('file', file);
                formData.append('fileName', 'file');
                formData.append('type', uploadFileType);
                formData.append('uploadPath', '');
                formData.append('imgSize', file.size);

                var _this = this;
                return NewApi.uploadNewApi.ajaxPromise(formData).done(function(data){
                    console.log(data);
                    var obj = _.pick(file, ['name', 'size', 'type']);
                    obj.uploadFileType = uploadFileType;
                    obj.uploadFilePath = uploadFileType === 'img' ? data : data.split(':')[0];
                    console.log(obj);
                    _this.value.push(obj);
                });
            },
            removeFile: function(index){
                this.value.splice(index, 1);
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-buyChannel/component/input-attach.js
// module id = 141
// module chunks = 4 5